/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { HighlightWithinTextarea } from 'react-highlight-within-textarea'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Grid, Snackbar } from '@material-ui/core/'
import MuiAlert from '@material-ui/lab/Alert'
import c from 'classnames'
import { setStep1 } from '../../../../modules/story/actions'
import { Button } from '../../../../components/UI/'
import arrowStepIcon from '../../../../assetss/img/arrowStepIcon.svg'
import './index.scss'

const Alert = props => {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const Step2 = () => {
  const [value, setValue] = useState('')
  const [openAlert, setOpenAlert] = useState(false)
  const [activeWrapper, setActiveWrapper] = useState(false)
  const [newActive, setNewActive] = useState(false)
  const history = useHistory()
  const { category } = useParams()
  const dispatch = useDispatch()
  const [error, setError] = useState('')
  const { step1 } = useSelector(({ story }) => story)
  const [errorText, setErrorText] = useState([])
  const [closeDefaultValue, setCloseDefaultValue] = useState(false)

  const checkStoryText = () => {
    let data = new FormData()
    data.append('text', value)
    data.append('lang', 'en')
    data.append('opt_countries', 'us,gb,fr')
    data.append('mode', 'standard')
    data.append('api_user', '634621962')
    data.append('api_secret', '8RrfqoABbUfiJg7YHyn2')

    axios({
      url: 'https://api.sightengine.com/1.0/text/check.json',
      method: 'post',
      data: data,
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then(({ data }) => {
        let filtered = data?.profanity?.matches?.filter(i => i?.type !== 'inappropriate' && i?.type !== 'other_profanity')
        if (filtered?.length) {
          filtered?.map(j => {
            setErrorText(prev => [...prev, [j?.start, j?.end + 1]])
            setOpenAlert(true)
            setError('We’ve noticed you’re using unacceptable content that violates our terms of use.')
            setValue(value + ' ')
          })
        } else {
          dispatch(setStep1({ text: value }))
          goTo('/new-story/step/3')
          setValue('')
          setError('')
        }
      })
      .catch(function (error) {
        if (error?.response) console?.error(error?.response?.data)
        else console?.error(error?.message)
      })
  }

  const goTo = path => history.push(path)

  const onNext = () => {
    if (!value) {
      setOpenAlert(true)
      setError('You cannot post an empty story. Please take your time. Write your story.')
    } else {
      checkStoryText()
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  useEffect(() => {
    if (step1?.text) {
      setValue(step1?.text)
    }
  }, [step1?.text])

  useEffect(() => {
    setCloseDefaultValue(!!value)
  }, [value])

  return (
    <Grid className='boxStep2'>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      >
        <Alert onClose={handleClose} severity='error'>{error}</Alert>
      </Snackbar>

      <div onClick={() => setActiveWrapper(false)} className={c('wrapperActive', activeWrapper && newActive && 'wrapperActiveShow')} />

      <Typography className='subTitle'>
        Write your story
      </Typography>
      <Typography className='stepTitle'>
        {category === 'troubled' ? 'Take your time and write about what burdens you.' : 'Write about your life experience and make the world a better place by sharing what you’ve been through.'}
      </Typography>
      <Grid className='formaStep'>
        <div
          className='errorContainer'
          onKeyPress={() => setNewActive(true)}
          onMouseMove={() => setNewActive(true)}
          onClick={() => {
            setActiveWrapper(true)
            setCloseDefaultValue(true)
          }}
          onMouseLeave={() => setNewActive(false)}
        >
          <div className={c('defaultPlace', { defaultPlaceHidden: closeDefaultValue })}>My story is about..</div>
          <HighlightWithinTextarea
            className={c('inputStep', error && 'errorBorder')}
            highlight={errorText}
            value={value}
            onChange={e => setValue(e)}
          />
        </div>
        <img className='arrowStep' src={arrowStepIcon} alt='arrowStepIcon' />
        <Typography className='textInput'>
          {category !== 'troubled' ? 'Your life experience can help someone cope with problems in life. Because often we all go through similar life situations.' : 'Don’t be afraid to express your feelings – it’s okay to feel what you feel and it’s healing to share.'}
        </Typography>
      </Grid>
      <Grid className='btnStep'>
        <Button className='prevBtn' onClick={() => goTo('/new-story/step/1')}>
          Previous step
        </Button>
        <Button className='nextBtn' onClick={onNext}>
          Next step
        </Button>
      </Grid>
      <Typography className='textInputMobile'>
        {category !== 'troubled' ? 'Your life experience can help someone cope with problems in life. Because often we all go through similar life situations.' : 'Don’t be afraid to express your feelings – it’s okay to feel what you feel and it’s healing to share.'}
      </Typography>
    </Grid>
  )
}

export default Step2
